// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('request/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/request/requestList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getRequest = createAsyncThunk('request/getRequest', async id => {
  let response = []
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/request/requestEdit/${id}`)
    return response.data.Response
  } else {
    return response
  }
})

export const addRequest = createAsyncThunk('request/addRequest', async (CreateRequest) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/request/requestCreate`, {
    Request: {
      CreateRequest
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return CreateRequest
})

export const updateRequest = createAsyncThunk('request/addRequest', async (UpdateRequest) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/request/requestUpdate`, {
    Request: {
      UpdateRequest
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return UpdateRequest
})

export const changeStatus = createAsyncThunk('request/changeStatus', async (ChangeStatusRequest, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/request/requestChangeStatus`, {
    Request: {
      ChangeStatusRequest
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().requests.params))
  return ChangeStatusRequest
})

export const deleteRequest = createAsyncThunk('request/deleteRequest', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/request/requestDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  await dispatch(getData(getState().requests.params))
  return id
})

export const deleteRequestProduct = createAsyncThunk('request/deleteRequestProduct', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/request/requestProductDelete/${id}`)

  if (response.data.Response.Code === 1 && id > 0) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().requests.params))
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'requests',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedRequest: [],
    loading: false,
    loadingEdit: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getRequest.pending, (state) => {
        state.loadingEdit = true
      })
      .addCase(getRequest.fulfilled, (state, action) => {
        state.loadingEdit = false
        state.selectedRequest = action.payload.data
      })
      .addCase(deleteRequest.pending, (state) => {
        state.loading = true
      })
  }
})

export default appCategoriesSlice.reducer
